import axios from 'axios';
import Vue from 'vue/dist/vue.esm'

document.addEventListener('DOMContentLoaded', () => {
  const favourited = document.getElementById('favourited').value;
  const shop_slug = document.getElementById('shop_slug').value;
  new Vue({
    el: '#shop-show',
    data: {
      heartFilled: favourited == 'true'
    },
    methods: {
      like: function (event) {
        axios.defaults.headers.common = {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        };
        // see: https://stackoverflow.com/a/41008360/1285818
        var vm = this
        axios.post(`/shops/${shop_slug}/like`)
        .then(function (response) {
          vm.heartFilled = true
        })
        .catch(function (error) {
          alert("失敗しました 😢\nログインしていることを確認の上、画面をリロードし再度試してみてください")
        })
      },
      unlike: function (event) {
        axios.defaults.headers.common = {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        };
        var vm = this
        axios.delete(`/shops/${shop_slug}/unlike`)
        .then(function (response) {
          vm.heartFilled = false
        })
        .catch(function (error) {
          alert("失敗しました 😢\nログインしていることを確認の上、画面をリロードし再度試してみてください")
        })
      },
    }
  })
})
